<template>
  <p class="mb-2">Preciso que você indique o que cada coluna representa.</p>
  <p>
    <strong>Observação: </strong>Todas as colunas precisam ser relacionadas.Caso não queira
    importar os dados de alguma coluna, use a opção "Ignorar coluna".
  </p>

  <div class="table-container trf-wizard-table mt-3" style="max-height:58vh;overflow:auto;">
    <table
      class="table is-fullwidth is-hoverable is-narrow"
      id="trf-wizard-table-resizable"
    >
      <thead>
        <tr>
          <th class="has-text-left" style="width:165px" v-for="index in dadosTarefas.total" :key="index">
            <TrfChooserSimplesComValidacaoDeItemSelecionado
              placeholder="Selecione"
              :opcoesCabecalhosSelect="opcoesCabecalhosSelect"
              :valueOpcoes="valueOpcoes"
              @change="onChange"
            />
          </th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="(dadosTarefa, index) in dadosTarefas.rows" :key="index">
          <td
            class="content"
            v-for="(totalIndex, index) in dadosTarefas.rows[index].length"
            :key="index"
          >
            {{ dadosTarefa[index] }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import TrfChooserSimplesComValidacaoDeItemSelecionado from "./TrfChooserSimplesComValidacaoDeItemSelecionado";
export default {
  name: "TrfWizardModuloConfiguracaoTarefas",
  emits: ['change'],
  components: {
    TrfChooserSimplesComValidacaoDeItemSelecionado,
  },
  props: {
    dadosTarefas: Object,
    opcoesCabecalhosSelect: Array,
    valueOpcoes: Object,
  },
  data() {
    return {
      totalDeColunas: 3,
    };
  },
  methods: {
    onChange(value) {
      this.$emit("change", value);
    },
    adquirirDadosDaTabelaEDaColuna() {
      const tabela = document.getElementById("trf-wizard-table-resizable");
      const colunas = tabela.querySelectorAll("th");

      colunas.forEach((coluna) => {
        const resizer = document.createElement("div");
        resizer.classList.add("resizer");
        resizer.style.height = `${tabela.offsetHeight}px`;
        coluna.appendChild(resizer);

        this.criarColunaRedimensionavel(tabela, coluna, resizer);
      });
    },

    criarColunaRedimensionavel(tabela, coluna, resizer) {
      let inicialX = 0;
      let larguraInicial = 0;
      let larguraInicialTabela = 0;
      let isRedimensionando = false;
      let coordenadaHorizontal = 0;
      let larguraDaColuna = 0;

      const mouseDownHandler = (e) => {
        inicialX = e.pageX;
        larguraInicial = parseInt(window.getComputedStyle(coluna).getPropertyValue("width"));
        larguraInicialTabela = tabela.offsetWidth;
        isRedimensionando = true;

        coordenadaHorizontal = e.clientX;
        const styles = window.getComputedStyle(coluna);
        larguraDaColuna = parseInt(styles.width, 10);
        document.addEventListener("mousemove", mouseMoveHandler);
        document.addEventListener("mouseup", mouseUpHandler);
      };
      const mouseMoveHandler = (e) => {
        if (!isRedimensionando) return;

        const novaLarguraColuna = larguraInicial + e.pageX - inicialX;

        coluna.style.width = `${novaLarguraColuna}px`;
        tabela.style.width = `${larguraInicialTabela + e.pageX - inicialX}px`;

      };
      const mouseUpHandler = () => {
        document.removeEventListener("mousemove", mouseMoveHandler);
        document.removeEventListener("mouseup", mouseUpHandler);
      };
      resizer.addEventListener("mousedown", mouseDownHandler);
    },
  },
  computed: {
    cabecalhosArquivoEnviado() {
      let cabecalhosArquivoEnviado = {};
      let objetoReferencia = this.dadosTarefas[0];
      for (let i in objetoReferencia) {
        cabecalhosArquivoEnviado[i] = i;
      }
      return cabecalhosArquivoEnviado;
    },
  },
  mounted() {
    this.adquirirDadosDaTabelaEDaColuna();
  },
};
</script>

<style lang="scss">
.trf-wizard-table .table {
  border-collapse: collapse;
  table-layout: fixed;
  & th {
    background-color: #cccc;
    position: relative;
  }
}

.content .trf-wizard-table .table th {
  border: 1px solid #36363666;
}

.trf-wizard-table .table,
.trf-wizard-table .table th,
.trf-wizard-table .table td {
  border: 1px solid #ccc;
}

.resizer {
  position: absolute;
  top: 0;
  right: 0;
  width: 5px;
  cursor: col-resize;
  user-select: none;
}

.resizer:hover,
.resizing {
  border-right: 2px solid #363636;
}

.resizable {
  border: 1px solid gray;
  height: 100px;
  width: 100px;
  position: relative;
}

.trf-wizard-table select {
  background-color: transparent;
  border: none;
  width: 100%;
  cursor: pointer;
  outline: none;
}

.trf-wizard-table select.select {
  height: 1.5em;
}

.trf-wizard-table{
  scrollbar-width: thin;
  scrollbar-color: #969696 #dbdbdb;
 &::-webkit-scrollbar  {
  width: 6px;
  height: 5px;
  @media screen and (max-width: 768px) {
    width: 2px;
  }
}
&::-webkit-scrollbar-track {
  background: #dbdbdb;
  border-radius: 9px;
  margin: 0px 0;
}
&::-webkit-scrollbar-thumb {
  background-color: #969696;
  border-radius: 11px;
  border: 0px none #969696;
}
}
</style>
